export const EVENT_CARD_ORDER_CREATE = 'cardOrder.create'
export const EVENT_CARD_ORDER_UPDATE = 'cardOrder.update'
